<template>
  <div>
    <nuxt-layout name="default">
      <section
        class="container px-4 xl:px-0 mt-3 lg:mt-8 mb-6 lg:mb-12"
        v-if="!isCategoryLoading"
      >
        <p-breadcrumbs :breadcrumbs="breadcrumbs"></p-breadcrumbs>
        <div v-if="category && category.children.length">
          <div
            class="text-gray-900 font-lato font-semibold text-3xl lg:text-6xl my-4 md:my-6"
          >
            {{ category.name }}
          </div>
          <section
            class="grid gridCss sm:grid-cols-3 lg:grid-cols-4 gap-4"
            v-if="categoryChildren && categoryChildren.length"
          >
            <div v-for="item in categoryChildren" class="w-full">
              <p-wrapper
                class="min-w-40 min-h-40 h-full !w-full lg:h-68 p-4 cursor-pointer"
              >
                <nuxt-link :to="`/catalog/${item.public_id}`">
                  <div class="grid grid-cols-1 text-center">
                    <div class="place-self-center">
                      <img
                        :src="item.imageUrl ? item.imageUrl : image"
                        class="w-32 h-32 lg:w-42 lg:h-42 rounded-xl object-cover mb-4"
                      />
                    </div>
                    <div
                      class="text-base lg:text-xl font-lato text-gray-900 font-semibold place-self-center"
                    >
                      {{ item.name }}
                    </div>
                  </div>
                </nuxt-link>
              </p-wrapper>
            </div>
          </section>
        </div>
        <p-filters-by-category v-else />
      </section>
      <div v-else class="flex justify-center items-center mt-8 h-40">
        <p-loader class="w-20 h-15"></p-loader>
      </div>
    </nuxt-layout>
  </div>
</template>

<style scoped>
@media (max-width: 640px) and (min-width: 381px) {
  .gridCss {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }
}

@media (max-width: 380px) {
  .gridCss {
    grid-template-columns: repeat(1, minmax(0, 1fr)) !important;
  }
}
</style>
<script setup>
import POSITIVE_LOGO from "@/assets/img/positive-logo.png";
import { findBreadcrumbsById } from "~/utils/breadcrumbs";
import image from "~/assets/svgs/placeholder.svg";
import { routerKey } from "vue-router";
const { $get } = useAxios();
const route = useRoute();

// const { data: category, pending: isCategoryLoading } = await useAsyncData(
//   `get category by id - ${route.params.id}`,
//   () => $get(`/api/v1/category/${route.params.id}`),
//   { default: () => [], lazy: true }
// );

const category = ref(null);
const isCategoryLoading = ref(false);
async function getCategory() {
  isCategoryLoading.value = true;
  category.value = await $get(`/api/v1/category/${route.params.id}`);
  isCategoryLoading.value = false;
}

getCategory();

const categoryChildren = computed(() => {
  if (category.value && category.value?.children.length) {
    return category.value.children.sort((a, b) => a.priority - b.priority);
  }
  return [];
});

const breadcrumbs = computed(() => {
  if (category.value) {
    return findBreadcrumbsById(category.value.public_id);
  }
  return [];
});

const head = computed(() => {
  return {
    title: `ООО "Позитив"`,
    meta: [
      {
        hid: "title",
        property: "title",
        content: `${category.value?.name}`,
      },
      {
        hid: "og:title",
        property: "og:title",
        content: `${category.value?.name}`,
      },
      {
        hid: "description",
        name: "description",
        content: `${category.value?.name} купить по низким ценам - интернет магазин "Позитив"`,
      },
      {
        hid: "og:description",
        property: "og:description",
        content: `${category.value?.name} купить по низким ценам - интернет магазин "Позитив"`,
      },
      {
        hid: "url",
        name: "url",
        content: `https://positive.ooo/product/catalog/${category.value?.public_id}`,
      },
      {
        hid: "og:url",
        property: "og:url",
        content: `https://positive.ooo/product/catalog/${category.value?.public_id}`,
      },
      {
        hid: "image",
        name: "image",
        content: `${category.value?.imageUrl ?? POSITIVE_LOGO}`,
      },
      {
        name: "og:image",
        property: "og:image",
        content: `${category.value?.imageUrl ?? POSITIVE_LOGO}`,
      },
    ],
  };
});

useHead(head);
</script>
